import { NavLink } from "react-router-dom";
import CourseMenu from "../../assets/icons/CourseMenu";
import MenuDoc from "../../assets/icons/MenuDoc";
import MenuHome from "../../assets/icons/MenuHome";

const sidebarItems = [
	{ label: "خانه داشبورد", to: "/dashboard/", icon: MenuHome },
	{ label: "اسلایدر صفحه اصلی", to: "/dashboard/homepage-hero/", icon: MenuHome },
	{ label: "راهنمای عکس‌ها", to: "/dashboard/image-guidelines/", icon: MenuDoc },
	{ label: "ردیف‌های صفحه اصلی", to: "/dashboard/homepage-carousels/", icon: CourseMenu },
	{ label: "مدیریت دکترها", to: "/dashboard/doctors/", icon: MenuDoc },
	{ label: "مدیریت کاربران", to: "/dashboard/users/", icon: CourseMenu },
	{ label: "مدیریت کارگاه‌ها", to: "/dashboard/workshops/", icon: CourseMenu },
	{ label: "مدیریت ویدیو کلیپ", to: "/dashboard/video-clips/", icon: CourseMenu },
	{ label: "مدیریت وبینارها", to: "/dashboard/webinars/", icon: CourseMenu },
	{ label: "مدیریت اشتراک‌ها", to: "/dashboard/subscriptions/", icon: CourseMenu },
	{ label: "مدیریت مقالات", to: "/publication_list/", icon: MenuDoc },
	{ label: "مدیریت تالار گفتگو", to: "/discussion_list/", icon: CourseMenu },
];

export default function DashboardSidebar({ isDesktop }) {
	return (
		<aside className={`${isDesktop ? "w-[280px] shrink-0" : "w-full"} bg-white border border-[#E2E8F0] rounded-[10px] p-3`}>
			<div className="px-3 py-4 border-b border-[#E2E8F0]">
				<p className="font-Vazir-700 text-[18px] text-darkBlue">داشبورد مدیریت</p>
			</div>
			<nav className={`${isDesktop ? "flex-col" : "overflow-x-auto"} flex gap-2 pt-3`} aria-label="منوی داشبورد">
				{sidebarItems.map((item) => {
					const Icon = item.icon;

					return (
						<NavLink
							key={item.to}
							to={item.to}
							end={item.to === "/dashboard/"}
							className={({ isActive }) => [
								"flex items-center gap-3 rounded-[10px] px-3 py-3 font-Vazir-600 text-[14px] transition-colors whitespace-nowrap",
								isActive
									? "bg-lightCta text-darkBlue"
									: "text-midGray hover:bg-lightCta/70 hover:text-darkBlue",
							].join(" ")}
						>
							<Icon color="#276AA6" width={22} height={22} />
							{item.label}
						</NavLink>
					);
				})}
			</nav>
		</aside>
	);
}
